import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DataViewModelValue } from '@components/ui/table-template/models/data-view-model-value';
import { IconViewModel } from '@components/ui/table-template/models/icon-view-model';
import { TableTemplateColumnConfig } from '@components/ui/table-template/models/table-template-column-config';
import { DataViewModel } from '@components/ui/table-template/models/data-view-model';
import { TableCell } from '@components/ui/table-template/cells/table-cell';

@Component({
    selector: 'app-table-cell-icon',
    templateUrl: './table-cell-icon.component.html',
    styleUrls: ['./table-cell-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AngularSvgIconModule]
})
export class TableCellIconComponent implements TableCell {
  public readonly url = signal<string>('');
  public readonly alt = signal<string>('');
  public readonly size = signal<string>('');
  public readonly colour = signal<string>('');

  initialize(column: TableTemplateColumnConfig, row: DataViewModel, cell: DataViewModelValue): void {
    const model = cell as IconViewModel;
    this.url.set(model.url);
    this.alt.set(model.alt);
    this.size.set(model.size);
    this.colour.set(model.colour);
  }
}
